import React, { ChangeEvent, useCallback, useEffect } from 'react';

export type IgnoreClickOutsideProperty = string | React.MutableRefObject<Element>;

export const useOnClickOutside = ({
  ref,
  handler,
  ignoreList = [],
  disabled,
}: {
  ref: React.RefObject<HTMLElement>;
  handler: (event: ChangeEvent) => any;
  ignoreList?: IgnoreClickOutsideProperty[];
  disabled?: boolean;
}) => {
  let listener: any;
  // eslint-disable-next-line prefer-const
  listener = useCallback(
    (event: React.ChangeEvent) => {
      event.stopPropagation();
      // Do nothing if clicking ref's element or descendent elements

      const elements = ignoreList.reduce<Element[]>((acc, element) => {
        if (typeof element === 'string') {
          document.querySelectorAll(element).forEach(node => {
            acc.push(node);
          });
        } else if (element?.current) {
          acc.push(element.current);
        }
        return acc;
      }, []);

      const isContain = elements.some((elem: any) => {
        return elem && elem.contains(event.target);
      });

      if (!ref?.current || ref?.current?.contains(event.target) || isContain) {
        return;
      }

      handler(event);
    },
    [ref, handler, ignoreList],
  );

  useEffect(() => {
    if (disabled) {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    } else {
      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
    }
  }, [disabled, listener]);

  useEffect(() => {
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [listener]);
};
